import Vue from "vue";
import App from "./App.vue";
import { Toast, Button, Search, Popover, Popup, Field, Picker, Icon, Checkbox, CheckboxGroup, Cell, CellGroup, Divider, Uploader } from "vant";
import api from "./api";
import VueI18n from "vue-i18n";
import store from "./store"; // 导入 Vuex 仓库
import commonMixin from "./mixins/commonMixins.js"; // 导入公共混入函数
import VConsole from "vconsole";

Vue.config.productionTip = false;
// vant组件引入
Vue.use(Toast); // 轻提示组件
Vue.use(Button); // 按钮组件
Vue.use(Search); // 搜索组件
Vue.use(Popover); // 气泡弹出框组件
Vue.use(Popup); // 弹出层组件
Vue.use(Field); // 输入框组件
Vue.use(Picker); // 选择器组件
Vue.use(Icon); // 图标组件
Vue.use(Checkbox); // 复选框组件
Vue.use(CheckboxGroup); // 复选框组组件
Vue.use(Cell); // 单元格组件
Vue.use(CellGroup); // 单元格组组件
Vue.use(Divider); // 分隔线组件
Vue.use(Uploader); // 上传组件

// 挂载到 Vue 原型
Vue.prototype.$api = api;
Vue.prototype.$toast = Toast;
// 国际化插件引入
Vue.use(VueI18n);
// 全局注册mixin
Vue.mixin(commonMixin);
// const isProd = process.env.NODE_ENV === "production";
// if (!isProd) {
//   // 所有环境均使用
//   new VConsole()
// }

const i18n = new VueI18n({
  locale: "zh-CN", // 默认语言为英文
  messages: {
    "zh-CN": require("./locales/zh-CN.js").default,
    en: require("./locales/en.js").default,
  },
});

new Vue({
  i18n,
  store, // 挂载仓库（全局可用 this.$store 访问）
  render: (h) => h(App),
}).$mount("#app");
